import React, { useEffect, useState, createElement } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, CreditCard } from 'lucide-react';
declare global {
  interface Window {
    PaystackPop: any;
  }
}
const GiftPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    item,
    price,
    type
  } = location.state || {};
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  // Convert price string to number (remove ₦ and commas)
  const amountInNaira = price && price !== 'Your Choice' ? parseInt(price.replace(/[₦,]/g, '')) : 0;
  const [customAmount, setCustomAmount] = useState(amountInNaira);
  const publicKey = 'pk_live_a0b5ca74ab3a42c1be461b187be6c087abc6decd';
  useEffect(() => {
    // Load Paystack inline script
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      const existingScript = document.querySelector('script[src="https://js.paystack.co/v1/inline.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);
  if (!item) {
    navigate('/');
    return null;
  }
  const handlePayment = () => {
    if (!window.PaystackPop) {
      alert('Payment system is loading. Please try again in a moment.');
      return;
    }
    setIsProcessing(true);
    const handler = window.PaystackPop.setup({
      key: publicKey,
      email: email,
      amount: customAmount * 100,
      currency: 'NGN',
      ref: 'GIFT_' + Math.floor(Math.random() * 1000000000 + 1),
      metadata: {
        custom_fields: [{
          display_name: 'Gift Item',
          variable_name: 'gift_item',
          value: item
        }, {
          display_name: 'Gift Type',
          variable_name: 'gift_type',
          value: type
        }, {
          display_name: 'Donor Name',
          variable_name: 'donor_name',
          value: name
        }, {
          display_name: 'Phone Number',
          variable_name: 'phone',
          value: phone
        }]
      },
      onClose: function () {
        setIsProcessing(false);
        alert('Payment window closed. You can try again anytime.');
      },
      callback: function (response: any) {
        setIsProcessing(false);
        alert(`Thank you for your generous gift! Payment successful. Reference: ${response.reference}`);
        navigate('/');
      }
    });
    handler.openIframe();
  };
  const isFormValid = email && name && phone && customAmount > 0;
  return <div className="min-h-screen bg-cream" data-id="element-157">
      <div className="section-container" data-id="element-158">
        <button onClick={() => navigate(-1)} className="flex items-center text-gray-700 hover:text-emerald mb-8 transition-colors" data-id="element-159">
          <ArrowLeft size={20} className="mr-2" data-id="element-160" />
          Back
        </button>

        <div className="max-w-2xl mx-auto" data-id="element-161">
          <h1 className="section-heading" data-id="element-162">Complete Your Gift</h1>

          <div className="bg-white border border-sage border-opacity-60 p-8 rounded-md shadow-md mb-8" data-id="element-163">
            <h2 className="font-serif text-2xl text-gray-800 mb-2" data-id="element-164">
              Selected Gift
            </h2>
            <p className="text-gray-700 text-lg mb-1" data-id="element-165">{item}</p>
            <p className="text-emerald font-semibold text-2xl mb-4" data-id="element-166">{price}</p>
            <p className="text-gray-600 text-sm" data-id="element-167">Category: {type}</p>
          </div>

          <div className="bg-white border border-sage border-opacity-60 p-8 rounded-md shadow-lg" data-id="element-168">
            <div className="flex items-center justify-center mb-6" data-id="element-169">
              <div className="w-16 h-16 bg-emerald rounded-full flex items-center justify-center" data-id="element-170">
                <CreditCard size={28} className="text-white" data-id="element-171" />
              </div>
            </div>

            <h2 className="font-serif text-2xl text-gray-800 mb-6 text-center" data-id="element-172">
              Payment Details
            </h2>

            <form className="space-y-4" onSubmit={e => {
            e.preventDefault();
            handlePayment();
          }} data-id="element-173">
              <div data-id="element-174">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-175">
                  Full Name *
                </label>
                <input type="text" value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald focus:border-emerald outline-none transition-all" placeholder="Enter your full name" required data-id="element-176" />
              </div>

              <div data-id="element-177">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-178">
                  Email Address *
                </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald focus:border-emerald outline-none transition-all" placeholder="your.email@example.com" required data-id="element-179" />
              </div>

              <div data-id="element-180">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-181">
                  Phone Number *
                </label>
                <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald focus:border-emerald outline-none transition-all" placeholder="+234 800 000 0000" required data-id="element-182" />
              </div>

              {price === 'Your Choice' && <div data-id="element-183">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-184">
                    Amount (₦) *
                  </label>
                  <input type="number" value={customAmount} onChange={e => setCustomAmount(parseInt(e.target.value) || 0)} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald focus:border-emerald outline-none transition-all" placeholder="Enter amount" min="1000" required data-id="element-185" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-186">Minimum: ₦1,000</p>
                </div>}

              <div className="pt-4" data-id="element-187">
                <button type="submit" disabled={!isFormValid || isProcessing} className={`w-full px-8 py-4 font-sans text-sm uppercase tracking-wider transition-all duration-300 shadow-md ${isFormValid && !isProcessing ? 'bg-emerald text-white hover:bg-emerald-dark hover:shadow-lg cursor-pointer' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`} data-id="element-188">
                  {isProcessing ? 'Processing...' : 'Pay with Paystack'}
                </button>
              </div>

              <div className="mt-6 p-4 bg-sage bg-opacity-30 rounded-md" data-id="element-189">
                <p className="text-sm text-gray-700 text-center" data-id="element-190">
                  <span className="font-semibold" data-id="element-191">Secure Payment:</span> Your
                  payment is processed securely through Paystack. We accept
                  cards, bank transfers, and USSD.
                </p>
              </div>
            </form>
          </div>

          <div className="mt-8 text-center" data-id="element-192">
            <p className="text-gray-600 italic font-script text-xl mb-4" data-id="element-193">
              Thank you for your generous gift!
            </p>
            <p className="text-sm text-gray-500" data-id="element-194">
              You will receive a payment confirmation via email after successful
              payment.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default GiftPayment;